/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type WorkingMaterialDto = {
    readonly id?: string;
    readonly createdDate?: string;
    readonly createdBy?: string;
    readonly modifiedDate?: string;
    readonly modifiedBy?: string;
    readonly version?: number;
    majorAssemblyModel: string;
    modelSeries?: string;
    operatingFluid?: string;
    majorAssemblyDesignation?: string;
    code?: string;
    sheetNumber?: string;
    saeGrade?: string;
    remark?: string;
    footnote?: string;
    fillingQuantity?: string;
    codeModel?: string;
    product?: string;
    gearType?: string;
    fileType: WorkingMaterialDto.fileType;
    salesDesignation?: string;
};
export namespace WorkingMaterialDto {
    export enum fileType {
        REAR_AXLE_DIFFERENTIAL = 'REAR_AXLE_DIFFERENTIAL',
        FRONT_AXLE_DIFFERENTIAL = 'FRONT_AXLE_DIFFERENTIAL',
        TRANSFER_CASE = 'TRANSFER_CASE',
        GEARBOX = 'GEARBOX',
        STEERING_GEAR = 'STEERING_GEAR',
        ENGINE_OIL = 'ENGINE_OIL',
        BRAKE_FLUID = 'BRAKE_FLUID',
        FUEL = 'FUEL',
        GREASE = 'GREASE',
        HYDRAULIC_OIL = 'HYDRAULIC_OIL',
        PRESERVATIVES = 'PRESERVATIVES',
        COMPRESSOR_OIL = 'COMPRESSOR_OIL',
        CORROSION_FROST_PROTECTION = 'CORROSION_FROST_PROTECTION',
        REFRIGERANT = 'REFRIGERANT',
        WINDSHIELD_WASHER_FLUID = 'WINDSHIELD_WASHER_FLUID',
        ELECTRIC_DRIVES = 'ELECTRIC_DRIVES',
    }
}

